import api from './index'

const axios = require('axios')

export default {
    getSummary: (filterSerialNumber) => {

        if(filterSerialNumber!=''){
            const path = '/settlements/summary/'+filterSerialNumber
            return api.handling(axios.get(path))
        }
        else{
            const path = '/settlements/summary'
            return api.handling(axios.get(path))
        }
    },

    getAll: (items, page) => {
        const path = '/settlements/all'

        return api.handling(axios.get(path, {
            params: {
                items: items,
                page, page
            }
        }))
    },

    request: (id, data) => {
        const path = `/settlements/${id}/request`

        //return api.handling(axios.post(path))
        return api.handling(axios.post(path, data))
    }
}
